import {
  printedcircuitboard,
  componentSide,
  solderSide
} from 'src/constants/typenames'
import { darken, lighten, complement, rgb } from 'polished'
import { default as parseColor } from 'color-parse'
/**
 * Colors are used in mst, threejs and html/css
 * - mst => Root.colors
 * - theme-ui
 *
 */

export const green = 'green' as const
export const yellow = 'yellow' as const
export const blue = 'blue' as const
export const orange = 'orange' as const
export const red = 'red' as const
export const transparent = 'transparent' as const
export const black = 'black' as const
export const white = 'white' as const

// export type ColorName =
//   | typeof green
//   | typeof yellow
//   | typeof blue
//   | typeof orange
//   | typeof red
//   | typeof transparent
//   | typeof black
//   | typeof white

export const coverColors = [
  green,
  yellow,
  blue,
  orange,
  red,
  transparent,
  black,
  white
]

export const engravingColors = [green, yellow, blue, orange, red, black, white]

// export default [green, yellow, blue, orange, red, transparent, black, white]

const coverColorMap = {
  [yellow]: '#FFEA3F',
  [red]: '#D23C53',
  [orange]: '#FD8100',
  [green]: '#0C8524',
  [transparent]: 'rgba(25,245,245,0.2)',
  [blue]: '#4165E9',
  [black]: 'rgb(5,5,5)',
  [white]: 'rgb(250,250,250)'
}

export type ColorName = keyof typeof colorMap

const mdf = '#AC9279'
const mdfEdging = '#141613'

const adapterPlate = mdf
const adapterPlateEdging = mdfEdging

const AdapterPlate = {}

export const navigationDefault = '#90BCA4'
export const navigationActive = '#3F7A5B'

const pcb = 'green'

/**
 *
 *
 */
export type StaticColor = {
  [key in 'default' | 'dark' | 'darker' | 'light' | 'lighter' | 'complement']: {
    hex: string
    rgba: string
    alpha: number
  }
}

const buildStaticColor = (color: string): StaticColor => {
  const variants = {
    default: color,
    dark: darken(0.2, color),
    darker: darken(0.5, color),
    light: lighten(0.2, color),
    lighter: lighten(0.5, color),
    complement: complement(color)
  }
  const staticColor = Object.entries(variants).reduce((prev, [key, value]) => {
    const { values, alpha } = parseColor(value)
    return {
      ...prev,
      [key]: {
        alpha,
        hex: rgb(...values),
        rgba: `rgba(${values.join(',')},${alpha})`
      }
    }
  }, {} as StaticColor)

  return staticColor
}

export const colorMap = {
  ...Object.entries(coverColorMap).reduce(
    (prev, [key, value]) => ({ ...prev, [key]: buildStaticColor(value) }),
    {} as Record<keyof typeof coverColorMap, StaticColor>
  ),
  [printedcircuitboard]: buildStaticColor('#3F7A5B'),
  [componentSide]: buildStaticColor('#3F7A5B'),
  [solderSide]: buildStaticColor('#3F7A5B')
  // [adapterPlate]: mdf
}

const colorNames = Object.keys(colorMap) as (keyof typeof colorMap)[]

export default colorNames
